<span *ngIf="block" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></span>
